import React from 'react'
import { Text, Icon } from "@fluentui/react";
//import "office-ui-fabric-react/dist/css/fabric.css";
import PropTypes from 'prop-types';

function StadisticCard(props) {

    //Parametros de entrada.
    const { 
        inputParam_Item = null,
        inputParam_SelectedItem = null,
        inputParam_ArrayLength = 0,
        inputParam_Index = 0,
        inputParam_SetterSelectedItem = null,
    } = props;
    
    const styles = {
        header: {
            root: {
                fontSize: 12,
                fontWeight: "bold",
                padding: "10px"
            }
        },
        amount: {
            root: {
                fontSize: "20px",
                verticalAlign: "middle",
            }
        }
    };
    const onStadisticCardSelected = () => {
        if (inputParam_SelectedItem && inputParam_Item.type === inputParam_SelectedItem.type) {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(null);
        }
        else {
            inputParam_SetterSelectedItem && inputParam_SetterSelectedItem(inputParam_Item);
        }
    }

    return (
            <div onClick={onStadisticCardSelected} className={ inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type ? "selected-stadistic-card" : ""} index={inputParam_Index} length={inputParam_ArrayLength}  style={{cursor: "pointer", borderRight: inputParam_ArrayLength > inputParam_Index ? "1px solid #b7b7b7" : ""}}>
                <div style={{display: inputParam_Item.display ? "block" : "none"}}>
                    <div className="text-center">
                        {
                            inputParam_SelectedItem && inputParam_SelectedItem.type === inputParam_Item.type &&
                            <Icon style={{ fontSize: "x-small", fontWeight: "600", color: "orange", position: "absolute", marginLeft: "-12px" }} iconName="Glimmer" />
                        }
                        <i style={{ fontSize: 25, verticalAlign: "middle", color: inputParam_Item.color}} className={ `ms-Icon ms-Icon--${inputParam_Item.icon}` } ></i>
                        <Text className="ps-1" styles={styles.amount}>{inputParam_Item.amount}</Text>
                    </div>
                    <div style={{fontSize: "small"}} className="text-center">
                        {inputParam_Item.title}
                    </div>
                </div>
            </div>
    );
}

///Proptypes
StadisticCard.propTypes = {
    inputParam_Item: PropTypes.object.isRequired,
    inputParam_SelectedItem: PropTypes.object,
    inputParam_ArrayLength: PropTypes.number.isRequired,
    inputParam_Index: PropTypes.number.isRequired,
    inputParam_SetterSelectedItem: PropTypes.func.isRequired,
};

export default StadisticCard;

